import { render } from "./TandCsModal.vue?vue&type=template&id=08308c63&scoped=true&lang=pug"
import script from "./TandCsModal.vue?vue&type=script&lang=ts"
export * from "./TandCsModal.vue?vue&type=script&lang=ts"

import "./TandCsModal.vue?vue&type=style&index=0&id=08308c63&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08308c63"

export default script